<template>
  <div class="table-header">
    <h2 class="view-header">
      {{ name }}
      <a-tooltip>
        <template slot="title"> Copy Table Link </template>
        <span @click="copyTableLink" class="action-button"
          ><a-icon width="20" height="20" icon="carbon:link"
        /></span> </a-tooltip
      ><a-tooltip>
        <template slot="title"> Add Bookmark </template>
        <span @click="saveBookmark" class="action-button"
          ><a-icon width="20" height="20" icon="material-symbols:bookmark-outline"
        /></span>
      </a-tooltip>
    </h2>
    <p v-if="description" class="table-header-description">{{ description }}</p>
  </div>
</template>

<script>
import { message, Tooltip } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import { buildProjectDeepLinkQuery } from '@/utils/deep-link'

const { mapActions: bookmarksAction, mapState: bookmarksState } = createNamespacedHelpers('bookmarks')

export default {
  name: 'TableHeader',
  components: {
    'a-tooltip': Tooltip
  },
  props: {
    title: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...bookmarksState({
      bookmarks: state => state.bookmarks
    }),
    name() {
      return (
        this.title ??
        (this.$route?.meta?.title || '')
          .replace(/-/g, '')
          .replace(/ePeople/g, '')
          .trim()
      )
    },
    url() {
      const currentQuery = buildProjectDeepLinkQuery({
        currentQuery: this.$route.query,
        projectId: this.$store.state.applicationState.currentProject?.id
      })

      const resolved = this.$router.resolve({
        name: this.$route.name,
        query: currentQuery
      })

      const fullUrl = window.location.origin + resolved.href
      return fullUrl
    }
  },
  methods: {
    ...bookmarksAction(['createBookmark']),

    copyTableLink() {
      navigator.clipboard
        .writeText(this.url)
        .then(() => {
          message.success('Link to table successfully copied!', 5)
        })
        .catch(() => {
          message.error('Unable copy link!', 5)
        })
    },

    generateUniqueName(baseName) {
      if (!this.bookmarks || !Array.isArray(this.bookmarks)) {
        return baseName
      }

      const existingNames = this.bookmarks.map(b => b.name)

      if (!existingNames.includes(baseName)) {
        return baseName
      }

      let maxIndex = 0
      const regex = new RegExp(`^${this.escapeRegExp(baseName)} \\((\\d+)\\)$`)

      existingNames.forEach(name => {
        const match = name.match(regex)
        if (match) {
          const index = parseInt(match[1], 10)
          if (index > maxIndex) maxIndex = index
        }
      })

      return `${baseName} (${maxIndex + 1})`
    },

    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },

    async saveBookmark() {
      try {
        const baseName = this.name
        const uniqueName = this.generateUniqueName(baseName)

        const payload = {
          bookmark: {
            name: uniqueName,
            url: this.url,
            is_favorite: false
          }
        }

        await this.createBookmark(payload)
        message.success(`Bookmark "${uniqueName}" successfully saved!`, 5)
      } catch (error) {
        console.error('Error saving bookmark:', error)
        message.error('Failed to save bookmark.', 5)
      }
    }
  }
}
</script>

<style scoped>
.table-header-description {
  margin: -4px 0 12px;
  color: var(--text-color-secondary);
  max-width: 920px;
}
</style>
